module.exports = __webpack_public_path__ + "img/5.99468af8.png";